export default __webpack_public_path__ + "static/media/giving background.329d1161.jpg";